'client only';
import Keycloak from 'keycloak-js';

const adminClientId = process.env.NEXT_PUBLIC_AUTH_SERVER_ADMIN_CLIENT_ID ?? 'admin';

export const keycloakAdminConfig = {
  url: process.env.NEXT_PUBLIC_AUTH_SERVER_URL as string,
  realm: process.env.NEXT_PUBLIC_AUTH_SERVER_REALM as string,
  clientId: adminClientId,
};

let keycloakAdmin: Keycloak | undefined;

if (typeof window !== 'undefined') {
  keycloakAdmin = new Keycloak(keycloakAdminConfig);
}

let isInitialized = false;

export const initKeycloakAdmin = (): Promise<boolean> => {
  if (!keycloakAdmin) return Promise.resolve(false);
  if (!isInitialized) {
    isInitialized = true;
    return keycloakAdmin
      .init({ onLoad: 'login-required', flow: 'standard', pkceMethod: 'S256' })
      .then(authenticated => {
        return authenticated ?? false;
      })
      .catch(err => {
        isInitialized = false;
        throw err;
      });
  }
  return Promise.resolve(keycloakAdmin.authenticated ?? false);
};

export const getAdminToken = async (): Promise<string | null> => {
  if (!keycloakAdmin) return null;
  if (keycloakAdmin.isTokenExpired?.()) {
    try {
      await keycloakAdmin.updateToken(30);
    } catch {
      keycloakAdmin.logout({ redirectUri: window.location.origin });
      return null;
    }
  }
  return keycloakAdmin.token ?? null;
};

export { keycloakAdmin };
